"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _get = _interopRequireDefault(require("./get.js"));
var _toJS = _interopRequireDefault(require("./toJS.js"));
// @ts-check

/**
 * @param {any} a
 * @param {any[]} path
 * @returns {any}
 */
var toMap = function toMap(a, path) {
  var next = (0, _get["default"])(a, path, (0, _reshowConstant.NEW_OBJ)());
  var nextMap = (0, _reshowConstant.NEW_OBJ)();
  if (next.forEach) {
    next.forEach(
    /**
     * @param {any} v
     * @param {number} k
     */
    function (v, k) {
      return nextMap[k] = (0, _toJS["default"])(v);
    });
  } else {
    (0, _reshowConstant.KEYS)(next).forEach(function (k) {
      return nextMap[k] = (0, _toJS["default"])(next[k]);
    });
  }
  return nextMap;
};
var _default = exports["default"] = toMap;
module.exports = exports.default;